import { Directive } from '@angular/core';

@Directive({
  selector: '[prepPageLayoutContent],prep-page-layout-content',
  host: {
    class: 'prep-page-layout-content'
  }
})
export class PageLayoutContentDirective {

  constructor() { }

}
